/** @mui/material imports */
/** @mui/icons-material imports */
/** React imports */
/** App imports */
import { ColumnHeader } from '@goldspotdiscoveries/atoms/lib/upload-logs-modal/vars/types';
import { SignalMap } from '../../TypeScript/interfaces';
import { errorHandler } from '../../utils/error/error-handler';

/**
 * Attempt to predict some columns from column header names
 * @param columnHeaders an array of column headers
 * @returns suggested signals map
 * @private
 */
export const getColumnHeaderPredictions = (
  columnHeaders: ColumnHeader[],
): Promise<Record<string, any>> => {
  return new Promise((resolve, reject) => {
    const worker = new Worker('/predict-column-properties.js');
    worker.onmessage = (
      ev: MessageEvent<{
        named: Record<ColumnHeader, string>;
        signals: Record<ColumnHeader, SignalMap>;
      }>,
    ) => {
      const mappedColumnHeaders: any = ev.data;
      const mappedColumns: Record<string, any> = {
        bhidCol: mappedColumnHeaders.bhidCol || '',
        depthCol:
          mappedColumnHeaders.depthCol ||
          mappedColumnHeaders.depthMaxCol ||
          mappedColumnHeaders.depthMinCol ||
          '',
        depthMinCol: mappedColumnHeaders.depthMinCol || '',
        depthMaxCol: mappedColumnHeaders.depthMaxCol || '',
        inputSignals: mappedColumnHeaders.inputSignals || null,
      };
      worker.terminate();
      resolve(mappedColumns);
    };
    worker.onerror = (error: ErrorEvent) => {
      reject();
      errorHandler(error as any);
    };
    worker.postMessage(columnHeaders);
  });
};
